// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (min-width:922px){.main-container[data-v-153a0fd2]{padding-left:1rem;padding-right:1rem}}.app[data-v-153a0fd2]{background-color:#f0f3f5;min-height:100vh}.main-container[data-v-153a0fd2]{max-width:1600px;padding-top:72px;padding-bottom:3rem}.profile-avatar[data-v-153a0fd2]{height:35px;border-radius:50%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
